module.exports = __webpack_public_path__ + "img/support-faq-panel.6d27c94.jpg";